export default {
  remote: 'simplify_hub_aws_management_mfe',
  name: 'aws-management',
  source: 'https://github.com/telus/cloud-coe-simplify-backstage-plugins',
  urlMapping: {
    localhost: 'https://assets.wcpreview.telus.com/642608889/ccoe-aws-management/v1/mf2/mf-manifest.json',
    'simplify.developers.telus.digital':
      'https://assets.wcpreview.telus.com/642608889/ccoe-aws-management/v1/mf2/mf-manifest.json',
    'simplify.staging.developers.telus.digital':
      'https://assets.wcstage.telus.com/642608889/ccoe-aws-management/v1/mf2/mf-manifest.json',
    'simplify.telus.com':
      'https://assets.telus.com/642608889/ccoe-aws-management/v1/mf2/mf-manifest.json',
  },
};
